:host {
  /* Other */
  --margin: var(--jb-time-input-margin, 0.75rem 0);
  --popover-z-index: var(--jb-time-input-popover-z-index, 1000);
}
